import { React, useState, useEffect } from "react";
import { useSendCode } from "../../../hooks/apis/auth";
import OTPModal from "../otp";
import { useAuthStore } from "../../../store/useUserStore";

function Register(props) {
  const { setAuth, authData } = useAuthStore((state) => state);

  const { mutate, isSuccess, isLoading, error, isError } = useSendCode();
  const [inputError, setInputError] = useState("");
  const [gender,setGender] = useState();
  const [popupOtp, setPopupOtp] = useState(false);

  //Handle Gender inputs
  const handleGender = (e) => {
    setGender(e);
  };

  //Close modal handle
  const handleClose = () =>{
    document.querySelector('.register_modal').classList.remove('active');
    document.querySelector('.modal').classList.remove('active');
  }
  //Handle OTP code
  let register_error = [];
  const handleRegister = () => {
    const userFirstName = document.querySelector("#userFirstName").value;
    const userLastName = document.querySelector("#userLastName").value;

    document.querySelector(".errors_register").innerHTML = "";

    if (userFirstName === "" || userFirstName == null) {
      register_error.push({ message: "لطفا نام خود را وارد کنید" });
    }
    if (userLastName === "" || userLastName == null) {
      register_error.push({ message: "لطفا نام خانوادگی خود را وارد کنید" });
    }
    if(gender == '' || gender == null){
      register_error.push({message:'لطفا جنسیت خود را مشخص کنید'});
    }

    if (register_error.length > 0) {
      //Show errors
      let nodes = register_error.map((err) => {
        let p = document.createElement("p");
        p.classList.add('mb-0');
        p.textContent = err.message;
        return p;
      });
      document.querySelector(".errors_register").append(...nodes);
    } else {
      //Call API
      mutate({ mobile: authData.phoneNumber });
      document.querySelector('.otp_modal').classList.add('active');
      // document.querySelector('.otp_modal').classList.add('d-block');
    }

    register_error = [];
  };

  useEffect(() => {
    if (isSuccess) {
      setAuth({ firstName: document.querySelector("#userFirstName").value , lastName: document.querySelector("#userLastName").value , gender: gender});
      setPopupOtp(true);
      document.querySelector('.register_modal').classList.remove('active');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <div
        style={{ width: "600px" }}
        className={props.showPop ? "popup active register_modal" : "popup register_modal"}
      >
        <span onClick={handleClose} className="close position-absolute" style={{top:"15px",right:"15px",cursor:"pointer"}}>
          <svg width="28" height="28" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path fill="#676767" fillRule="evenodd" d="M11.2929,3.29289 C11.6834,2.90237 12.3166,2.90237 12.7071,3.29289 C13.0976,3.68342 13.0976,4.31658 12.7071,4.70711 L9.41421,8 L12.7071,11.2929 C13.0976,11.6834 13.0976,12.3166 12.7071,12.7071 C12.3166,13.0976 11.6834,13.0976 11.2929,12.7071 L8,9.41421 L4.70711,12.7071 C4.31658,13.0976 3.68342,13.0976 3.29289,12.7071 C2.90237,12.3166 2.90237,11.6834 3.29289,11.2929 L6.58579,8 L3.29289,4.70711 C2.90237,4.31658 2.90237,3.68342 3.29289,3.29289 C3.68342,2.90237 4.31658,2.90237 4.70711,3.29289 L8,6.58579 L11.2929,3.29289 Z" />
          </svg>
        </span>
        <img
          src="/images/name-level.svg"
          className="img-fluid mx-auto d-block mb-4"
          width="180"
          style={{ marginTop: "-40px" }}
          alt="name-level"
        />
        <p className="text-center text-white mb-4" id="name_form">
          لطفا برای ایجاد حساب کاربری اطلاعات خود را وارد کنید
        </p>
        <div
          style={{ width: "85%" }}
          className="login-phone position-relative m-auto mb-2 align-items-center justify-content-between"
        >
          <input
            className="w-100 border border-secondary rounded text-white mb-2"
            type="text"
            name="userFirstName"
            id="userFirstName"
            placeholder="نام"
            style={{
              background: "#454545",
              padding: "0 10px 0 10px",
              outline: "0",
              fontSize: "15px",
            }}
            onChange={() => {
              setInputError("");
            }}
          />
          <input
            className="w-100 border border-secondary rounded text-white mb-2"
            type="text"
            name="userLastName"
            id="userLastName"
            placeholder="نام خانوادگی"
            style={{
              background: "#454545",
              padding: "0 10px 0 10px",
              outline: "0",
              fontSize: "15px",
            }}
            onChange={() => {
              setInputError("");
            }}
          />
          <p className="d-flex align-items-center">
            <label htmlFor="femaleGender" className="d-flex align-items-center justify-content-center border border-secondary rounded text-white btn link-warning" data-check={(gender == 'female') ? 'check' : ''} style={{width: "49%",marginLeft:"2%"}}>
              <input className="d-none" type="radio" name="registerGender" id="femaleGender" value="female" onChange={(e)=>{handleGender(e.target.value)}}/>
              زن
            </label>
            <label htmlFor="maleGender" className="d-flex align-items-center justify-content-center border border-secondary rounded text-white btn link-warning" data-check={(gender == 'male') ? 'check' : ''} style={{width: "49%"}}>
              <input className="d-none" type="radio" name="registerGender" id="maleGender" value="male" onChange={(e)=>{handleGender(e.target.value)}} />
              مرد
            </label>
          </p>
          <input
            onClick={handleRegister}
            className="rounded text-white"
            style={{
              width: "100%",
              border: "1px solid #ed1c24",
              background: "#ed1c24",
            }}
            type="button"
            name="registerSubmit"
            id="registerSubmit"
            value="عضویت"
          />
        </div>
        <div
          className="errors_register text-center text-warning m-auto"
          style={{ width: "93%" }}
        >
          {inputError}
        </div>
        <div className={isLoading ? "active loading" : "loading"}>
          <img src="/images/loading.svg" className="img-fluid" alt="loading" />
        </div>
      </div>

      {/* <OTPModal showPop={popupOtp} /> */}
    </>
  );
}

export default Register;
